
  import { Component, Vue } from "vue-property-decorator";
  import {
    getAPIAuthorizedHeader,
  } from "@/services/common";
  import Axios from "axios";
  import { API_STORE } from "@/config";
  import AsyncPageLoader from "@/views/AsyncPageLoader.vue";
  import Swal from 'sweetalert2'
  import { UpiRequest, UpiStatusRequest } from "@/models/upi";
  
  @Component({ components: { AsyncPageLoader } })
  export default class AddUpiGeteway extends Vue {
    public asyncPageLoader = false;
    public disableSubmitbutton = false
    public upiRequest = new UpiRequest();
    public upiStatusRequest = new UpiStatusRequest();
    public gatewayUrl = null;
    public isResponsePage = false;
    public transactionStatus = false;
  
    public async addFundFromUpi() {
        if(Number(this.upiRequest.amount) >=10 && Number(this.upiRequest.amount) <= 20000){
        let valid = await this.$validator.validateAll();
        if (valid) {
          this.disableSubmitbutton= true;
          this.$showLoader(true);
          this.upiRequest.userId = this.$userId;
          let response = await Axios.post(
            API_STORE.SERVICE + "upigate/createOrder",
            this.upiRequest,
            {
              headers: getAPIAuthorizedHeader(),
            }
          );
          this.disableSubmitbutton = false;
          this.$showLoader(false);
          console.log(response.data)
          if (response.data) {
            if(response.data.data.status){
              this.gatewayUrl = response.data.data.data.payment_url
              window.open(this.gatewayUrl, '_blank');
            }else{
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: response.data.data.msg,
                showConfirmButton: true
              });
            }
          
          }
        }
      }else{
        Swal.fire({
                position: 'center',
                icon: 'error',
                title: "₹10 - ₹20,000",
                showConfirmButton: true
              });
      }
  
    }

    //Check Status
    public async checkStatus(clientTxnId: string) {
      this.$showLoader(true);
      this.upiStatusRequest.userId = this.$userId;
      this.upiStatusRequest.txn_date = new Date();
      this.upiStatusRequest.isCallBack = false;
      this.upiStatusRequest.client_txn_id = clientTxnId;
      let response = await Axios.post(
        API_STORE.SERVICE + "upigate/checkStatus",
        this.upiStatusRequest,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.$showLoader(false);
      console.log(response.data)
      if (response.data) {
        if(response.data.data){
          this.isResponsePage = true;
          this.transactionStatus = response.data.data.data.status == 'success' ? true : false;
        }else{
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.data.data.remark,
            showConfirmButton: true
          });
        }
      
      }
  
    }
  
    mounted() {
      console.log(this.$route.query.client_txn_id)
      if(this.$route.query.client_txn_id){
        this.isResponsePage = true;
        this.checkStatus(this.$route.query.client_txn_id.toString());
      }
    }
  }
  